const backData = [
  {
    id: 1,
    name: "What is Node.js ?",
    img: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg",
    meaning: `Node.js is an open-source, cross-platform, back-end, JavaScript runtime environment that executes JavaScript code outside a web browser. Node.js lets developers use JavaScript to write command line tools and for server-side scripting—running scripts server-side to produce dynamic web page content before the page is sent to the user's web browser. Consequently, Node.js represents a "JavaScript everywhere" paradigm, unifying web-application development around a single programming language, rather than different languages for server- and client-side scripts.`
  },
  {
    id: 2,
    name: "Best Node.js Course for beginners (ACM Suggestion)",
    list1: "Node Udemy Course ",
    href1:
      "https://www.udemy.com/course/the-complete-nodejs-developer-course-2/",
    list2: "Introduction to Backend ",
    href2:
      "https://www.youtube.com/playlist?list=PL-Jc9J83PIiEnK1q9tuVrrORqKBexcE_J",
    list3:
      "It is highly recommended to follow the projects listed below after completing the basics of Node.js"
  },
  {
    id: 3,
    name: "Best Mern Stack Projects",
    img: "https://static.javatpoint.com/blog/images/mern-stack.png",
    meaning:
      "- JavaScript® (often shortened to JS) is a lightweight, interpreted, object-oriented language with first-class functions, and is best known as the scripting language for Web pages, but it's used in many non-browser environments as well. It is a scripting language that is dynamic, and supports object-oriented, functional programming styles. - JavaScript runs on the client side of the web, which can be used to design / program how the web pages behave on the occurrence of an event. JavaScript is an easy to learn and also powerful scripting language, widely used for controlling web page behavior. - Contrary to popular misconception, JavaScript is not Interpreted Java.",
    list1: "Social Media Website with MERN Stack ",
    href1: "https://www.udemy.com/course/mern-stack-front-to-back/",
    list2: "E-Commerce Website with MERN Stack",
    href2: "https://www.udemy.com/course/mern-ecommerce/"
  }
];

export default backData;
